import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateOrderFormField } from '../../redux_files/actions/orderFormActions';

const PlateSizeStep = () => {
  const dispatch = useDispatch();
  const { selectedDate, mealType, plateSize } = useSelector(state => state.orderForm);
  
  // Styles object
  const styles = {
    selectedDateDisplay: {
      marginBottom: '20px'
    },
    summaryRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    summaryRowWithMargin: {
      marginTop: '8px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  };
  
  return (
    <>
      <div className='selected-date-display' style={styles.selectedDateDisplay}>
        <div style={styles.summaryRow}>
          <span>Delivery Date:</span>
          <strong>{new Date(selectedDate).toLocaleDateString('en-IN', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' })}</strong>
        </div>
        <div style={styles.summaryRowWithMargin}>
          <span>Meal Type:</span>
          <strong>{mealType ? mealType.charAt(0).toUpperCase() + mealType.slice(1) : 'N/A'}</strong>
        </div>
      </div>
      <div className='options-grid'>
        <div
          className={`option-card ${plateSize === 'full' ? 'selected' : ''}`}
          onClick={() => dispatch(updateOrderFormField('plateSize', 'full'))}
        >
          <div className='option-icon'>🍲</div>
          <div className='option-label'>Full Plate</div>
        </div>
      </div>
    </>
  );
};

export default PlateSizeStep;
